<template>
  <div id="QuestionReview" class="d-flex flex-column p-2">
    <!-- <div class="header p-2">
      Customize the Simulation:
      <p class='description-text'>
        Click <span class="highlight-text">see my results</span> at any time to visualize the changes to the urban environment
      </p>
    </div> -->
    <div class="question-input-box p-2">

      <!-- QUESTION -->
      <div class="question p-2" v-for="(question,i) in questions" :key="i" >
        <div class="description-toggle text-left" @click="question.descriptionToggle = !question.descriptionToggle">
          <span v-show="question.descriptionToggle === false"> + </span>
          <span v-show="question.descriptionToggle === true"> &#8722; </span>
        </div>

        <div class="question-section">
          <div class="question-header text-left"> {{ i+1}}.  {{question.question}}</div>

          <div class="question-body text-left m-2" v-show="question.descriptionToggle">
            <p class="description-text">
              {{question.description}}
            </p>
          </div>

          <!-- CHECKBOX BUTTON -->
          <div class="question-checkbox text-left mt-2" v-if="question.type === 'input'" >
            <b-form-group>
              <b-form-checkbox-group 
                v-model="question.answer"
                :options="question.options"
                name="input-checkbox-review"
                @change="inputChange"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>

          <!-- RADIO BUTTON -->
          <div class="quesiton-radio text-left mt-2" v-if="question.type === 'radio'">
            <b-form-group>
              <b-form-radio-group
              v-model="question.answer" 
              :options="question.options"
              :name="question.question+'-radio-review'" 
              @change="inputChange"
              >
              </b-form-radio-group>
            </b-form-group>
          </div>
        </div>
      </div>

      <div class="border-break ml-2 mr-2"></div>

      <div class="annotation p-2" >
        <p>
          Note: Public space development is prioritized over energy generation when not enough land exists.
        </p>
      </div>
      
      <div class="logo-container mb-2 mt-2 ">
        <a href="https://ui.kpf.com" target="_blank">
          <img :src="logo" alt="kpfui-logo" class="ml-1">
        </a>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "QuestionReview",
  props:{
    questions: Array
  },
  data(){
    return{
      logo: require("@/assets//images/kpfui_logo.png")
    }
  },
  methods:{
    inputChange(){
      this.$emit('clearOptimize', null)
    }
  }
}
</script>

<style lang="scss">

#QuestionReview{

  background: $blue;

  .question{
    display: flex;
  }
  .highlight-text{
    color: $orange
  }
  .annotation{
    @include fontStyling($font-sm, $font-light, $off-white, none);
  }
  .description-text{
    @include fontStyling($font-description, $font-light, $off-white, none);
  }
  .question-header{
    @include fontStyling(1.1em, $font-med, $off-white, none);
  }

  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after{
    background-image: url("data:image/svg+xml,%3Csvg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23f2ebdf;%7D%3C/style%3E%3C/defs%3E%3Crect class='cls-1' width='6' height='6'/%3E%3C/svg%3E")!important;
  }

  .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
    background-image: url("data:image/svg+xml,%3Csvg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23f2ebdf;%7D%3C/style%3E%3C/defs%3E%3Crect class='cls-1' width='8' height='8' rx='4'/%3E%3C/svg%3E")!important;
  }

  .custom-control-label::after{
    width: 1.2rem!important;
    height: 1.2rem!important;
  }

  .custom-checkbox .custom-control-label::before, .custom-control-label::before, .custom-radio .custom-control-label::before{
    background: transparent!important;
    width: 1.2rem!important;
    height: 1.2rem!important;
    border-color: $off-white!important;
    border-width: 1px!important;
  }
  
  label{
    &:hover{
      cursor: pointer;
    }
  }

  .custom-control{
    margin-bottom: $spacer-md;
    cursor: pointer;
    label > span, label{
      margin-left: 15px;

      font-size: 1.2rem;
      font-weight: $font-reg;
      color: $off-white;
    }
  }

  .description-toggle{
    min-width: 20px;
    margin-right: 1rem;
    font-size: 1.7rem;
    font-weight: $font-med;
    color: $orange;

    span{
      position: relative;
      top: -5px;
      user-select: none;

      &:hover{
        cursor: pointer;
      }
    }
  }
  .logo-container{
    display: flex;
    justify-content: flex-end;

    img{
      height: 20px;
      width: auto;
    }
  }

  .question-input-box{
    position: relative;
    display: flex;
    flex-grow:1;
    flex-direction: column;
    background: $blue;
  }
}
</style>